export default __webpack_public_path__ + "static/AnniversarySaleHero-BG-Desktop-4d3bec98c815a947676638a031ba005a.webp";